import styled from "styled-components";

import { StrapiStyledImageProps } from "./StrapiImage.types";

export const StyledImage = styled.img<StrapiStyledImageProps>`
  object-fit: ${({ fit }) => fit || "cover"};
`;
